import React, { FC } from "react";

import { FieldError as FormFieldError } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormHelperText, { FormHelperTextProps } from "@mui/material/FormHelperText";

type FieldErrorProps = Omit<FormHelperTextProps, "error"> & {
    error: FormFieldError;
};

const FieldError: FC<FieldErrorProps> = ({ error, ...fieldErrorProps }) => {
    const { t } = useTranslation();

    if (!error?.message) {
        return <></>;
    }

    return (
        <FormHelperText role="alert" error {...fieldErrorProps}>
            {t(error.message)}
        </FormHelperText>
    );
};

export default FieldError;
